export default __webpack_public_path__ + "static/media/gallery - story - hand (1)_04.a2a37f4e.jpg";